import React from 'react';
import { Box, Heading, Text, Flex, useColorModeValue } from '@chakra-ui/react';
import { Book } from 'lucide-react';
import Page from '../../layout/IntegraAppPage';

const Configuracoes = () => {
  const corDeFundo = useColorModeValue('white', 'gray.800');
  const corDaBorda = useColorModeValue('gray.200', 'gray.700');
  const corTextoSecundario = useColorModeValue('gray.500', 'gray.400');

  return (
    <Page>
      {/* titulo */}
      <Box mb={6}>
        <Heading size="lg">Regras</Heading>
        <Text fontSize="sm" color={corTextoSecundario}>
          Regras de Negócio
        </Text>
      </Box>

      {/* card */}
      <Box
        bg={corDeFundo}
        border="1px solid"
        borderColor={corDaBorda}
        borderRadius="2xl"
        minH="300px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Flex direction="column" align="center" gap={3}>
          <Book size={40} color="gray" />

          <Text fontWeight="500">Módulo de Regras</Text>

          <Text fontSize="sm" color={corTextoSecundario} textAlign="center">
            Configure regras de preço, estoque, títulos e validações por canal{' '}
          </Text>
        </Flex>
      </Box>
    </Page>
  );
};

export default Configuracoes;
